<template>
  <div class="main">
    <div class="view-container">
      <div class="view-box" style="margin-top: 100px">
        <div>
          <div class="sett-title">【采购平台】项目员绩效结算申请表</div>
        </div>
        <div class="tab">
          <table
            cellpadding="0"
            cellspacing="0"
            border="1"
            style="width: 100%; text-align: center"
          >
            <!-- <thead style="text-align: center"> -->
            <tr>
              <th v-for="(item, index) in clos" :key="index">
                {{ item.label }}
              </th>
            </tr>
            <!-- </thead> -->
            <!-- <tbody style="text-align: center"> -->
            <tr v-for="(item, index) in list" :key="index">
              <td>{{ item.projectcode }}</td>
              <td>{{ item.projectname }}</td>
              <td>{{ item.Pcomname }}</td>
              <td>{{ item.projectlimitamt | qfwVal }}</td>
              <td>{{ item.pusername }}</td>
              <td>{{ item.confirmfeeamt | qfwVal }}</td>
              <td>{{ item.psufewreceivetime }}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- </tbody> -->
          </table>
        </div>
        <div class="fooder">
          <div class="f-box">
            <div class="item">
              <div class="laber">结算申请人：</div>
              <div class="values"></div>
            </div>
            <div class="item">
              <div class="laber">日期：</div>
              <div class="values"></div>
            </div>
          </div>
          <div class="f-box">
            <div class="item">
              <div class="laber">审批人：</div>
              <div class="values"></div>
            </div>
            <div class="item">
              <div class="laber">日期：</div>
              <div class="values"></div>
            </div>
          </div>
          <div class="f-box">
            <div class="item">
              <div class="laber">财务确认：</div>
              <div class="values"></div>
            </div>
            <div class="item">
              <div class="laber">日期：</div>
              <div class="values"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
export default {
  name: "settlemanetXMYPrint",
  filters: {},
  computed: {},
  data() {
    return {
      clos: [
        { prop: "projectcode", label: "项目编号" },
        { prop: "projectname", label: "项目名称" },
        { prop: "Pcomname", label: "采购人" },
        { prop: "projectlimitamt", label: "预算额（元）" },
        { prop: "ptcusername", label: "项目员" },
        { prop: "confirmfeeamt", label: "服务费（元）" },
        { prop: "psufewreceivetime", label: "收取日" },
        { prop: "", label: "结算金额" },
        { prop: "", label: "结算日" },
        { prop: "", label: "结算人" },
      ],
      list: [],
      query: {
        isMyself: 1,
        salerewardflg: 0,
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
      },
    };
  },
  async created() {
    await this.getPerformance();
  },
  filters: {
    qfwVal(value) {
      return utils.comdify(value);
    },
  },
  activated() {},
  components: {},
  mounted() {},
  methods: {
    async getPerformance() {
      this.query.isMyself = this.$route.query.isMyself;
      this.query.salerewardflg = this.$route.query.salerewardflg;
      this.query.startTime = this.$route.query.startTime;
      this.query.endtTime_c = this.$route.query.endtTime_c;

      let res = await request({
        url: "/basic/statisticalAnalysis/getXMYPerformance",
        method: "get",
        params: this.query,
      });
      res.data.map((e) => {
        e.psufewreceivetime = utils.formatterDate(
          e.psufewreceivetime,
          "yyyy-MM-dd"
        );
        e.projectlimitamt = utils.comdify(e.projectlimitamt);
        e.confirmfeeamt = utils.comdify(e.confirmfeeamt);
        return e;
      });
      this.list = res.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.sett-title {
  text-align: center;
  font-size: 23px;
  font-weight: bold;
  margin: 10px 0;
}
.fooder {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .item {
    margin: 10px 0;
  }
}
</style>
